/// <reference path="../types.d.ts" />

import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import * as dictionary from '../actions/dictionary';
import { LOAD_STATES } from './common';
import { logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';

const reducer = createReducer(InitialState.dictionaryTenants, builder => {
  builder.addCase(logout.type, () => ({ ...InitialState.dictionaryTenants }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.dictionaryTenants }));

  builder.addCase(dictionary.getTenantList.pending, state => {
    return { ...state, loadState: LOAD_STATES.started };
  });

  builder.addCase(dictionary.getTenantList.fulfilled, (state, action) => {
    const result = action.payload;
    const {
      sortablePageable: { pageableDefinition }
    } = state;
    const nextPageableDefinition = {
      ...pageableDefinition,
      numberOfElements: result.length,
      content: result,
      totalElements: result.length
    };

    return {
      ...state,
      loadState: LOAD_STATES.done,
      sortablePageable: {
        ...state.sortablePageable,
        pageableDefinition: nextPageableDefinition
      }
    };
  });
});

export default reducer;
